import { Constants, Utils } from "@zanichelli/myz-react-utils";

import { call, put, takeEvery, select } from "redux-saga/effects";

import { canUseMyzToken } from "../selectors";
import { subscriptionEmailSetEmail } from "../SubscriptionEmail/actions";
import { wotdFormDataSet } from "../WotdFormData/actions";
import { get } from "../../../utils/requestV3MyzToken";

import {
  IWotdPresetRequest,
  WotdPresetAction,
  WotdPresetActionEnum,
  wotdPresetFail,
  wotdPresetSuccess,
} from "./actions";

export function* wotdPresetRequestSaga(action: IWotdPresetRequest) {
  try {
    const useToken: boolean = yield select(canUseMyzToken);
    if (!useToken && !action.hash) throw new Error("Invalid request");

    const requestURL = useToken
      ? "wotd/subscriptions/logged"
      : `wotd/subscriptions/${action.hash}`;

    const requestOpt = {
      headers: useToken
        ? { [Constants.ENV.MYZ_TOKEN_KEY]: Utils.getMyzTokenCookie() }
        : {},
    };

    const { data } = yield call(get, requestURL, requestOpt);
    if (!useToken) yield put(subscriptionEmailSetEmail(data.data.email));
    yield put(wotdFormDataSet(data.data.words));
    yield put(wotdPresetSuccess(data));
  } catch (err) {
    yield put(wotdPresetFail(err));
  }
}

export function* sagas() {
  yield takeEvery(WotdPresetActionEnum.REQUEST, wotdPresetRequestSaga);
}

export interface IWotdPresetState {
  loading: boolean;
  loaded: null | boolean;
  data: any;
  error: null | Error;
}

const initialState: IWotdPresetState = {
  loading: false,
  loaded: null,
  data: null,
  error: null,
};

const WotdPreset = (
  state: IWotdPresetState = initialState,
  action: WotdPresetAction,
): IWotdPresetState => {
  switch (action.type) {
    case WotdPresetActionEnum.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case WotdPresetActionEnum.SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.data ? { ...action.data } : null,
      };
    case WotdPresetActionEnum.FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.err,
      };
    default:
      return state;
  }
};
export default WotdPreset;
